import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export interface WrapProps {
  bgColor?: string
}

export const AvatarWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  flex: 'none',
})<WrapProps>`
  border-radius: 50%;
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: ${props => props.bgColor || props.theme.colors.avatarBgColor || '#cccccc'};
  overflow: hidden;

  img {
    max-width: 100%;
    min-width: ${props => props.width};
  }
`;

export const Avatar = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;
